import { BaseSelect } from "@/shared/ui/base-select";
import { MenuItem, Stack, Typography } from "@mui/material";
import { useRouter } from "@tanstack/react-router";
import { useState } from "react";

type Props = {
  page: number;
  perPage: number;
  total: number;
};

export const PaginationControls = ({ page, perPage, total }: Props) => {
  const router = useRouter();

  const [value, setValue] = useState(perPage);

  const changePerPage = (perPage: number) => {
    setValue(perPage);
    router.navigate({
      to: `/notifications?perPage=${perPage}`,
    });
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent={{ xs: "space-between", sm: "flex-start" }}
      spacing={2}
    >
      <Typography fontSize={14}>
        {(page - 1) * perPage + 1} - {Math.min(page * perPage, total)} 件 / 全
        {` ${total} 件`}
      </Typography>

      <BaseSelect
        type="number"
        value={value}
        size="small"
        sx={{ width: 96 }}
        onChange={(value) => value && changePerPage(value)}
      >
        <MenuItem value={50}>50件</MenuItem>
        <MenuItem value={100}>100件</MenuItem>
      </BaseSelect>
    </Stack>
  );
};
